import React, { Component } from 'react'
import {LoginRequest} from './Api/Config'
import auth from './Auth';
import Preloader from './layouts/Preloader'


export class Login extends Component {
   
    state = {
        userId:'',
        password:'',
        userId_err:'',
        pwd_err:'',
        loginErr:'',
        isLoading:false
    }

componentDidMount(){
    if(auth.isValid===true){
        this.props.history.push('/admin')
    }
}

    isValid=()=>{
        let flag = true;
        if(this.state.userId.trim().length===0){
            this.setState({
                userId_err:'* empty email / username...!'
            })
            flag=false;
        }else{
            this.setState({
                userId_err:''
            })
        }

        if(this.state.password.trim().length===0){
            this.setState({
                pwd_err:'* empty password...!'
            })
            flag=false;
        }else{
            this.setState({
                pwd_err:''
            })
        }
        return flag;
    }

    handleChange=(e)=>{
        this.setState({
            [e.target.id]:e.target.value
        });
    }

    handleSubmit=(e)=>{
        e.preventDefault();
        if(this.isValid()){
            this.setState({isLoading:true})
            let req = {
                "email":this.state.userId,
                "password":this.state.password
            }
              LoginRequest('login',req).then(res=>{
                this.setState({isLoading:false})
                  if(res){
                      
                    localStorage.setItem('userDetails',JSON.stringify(res));
                        auth.login(()=>{
                            this.props.history.push("/admin")
                        });
                  }
                  
                }).catch(err=>{
                    this.setState({
                        loginErr:'Invalid login...!'
                    })
                  this.setState({isLoading:false})
                  console.log(err);
              })
        }
    }

    render() {
        return(
                <div>
                 <div className="valign-wrapper row login-box" style={{marginTop:100}}>
                <div className="col card hoverable s10 pull-s1 m6 pull-m3 l4 pull-l4">
                    {this.state.isLoading?<Preloader/>:null}
                    <form onSubmit={this.handleSubmit}>
                    
                    <div className="card-content">
                        <span className="card-title">Admin (Login)</span>
                        <div className="row">
                        <div className="input-field col s12">
                            <label htmlFor="userId">Username / email</label>
                            <input type="text" className="validate" id="userId" onChange={this.handleChange} />
                            <div style={{fontSize:12 ,color:"red"}}>{this.state.userId_err}</div>
                        </div>
                        <div className="input-field col s12">
                            <label htmlFor="password">Password </label>
                            <input type="password" className="validate" id="password" onChange={this.handleChange} />
                            <div style={{fontSize:12 ,color:"red"}}>{this.state.pwd_err}</div>
                        </div>
                        </div>
                        <div style={{fontSize:12 ,color:"red"}}>{this.state.loginErr}</div>
                    </div>
                    <div className="card-action right-align">
                        <input type="submit" className="btn green" value="Login"/>
                    </div>
                    </form>
                </div>
                </div>
            </div>
        )
    }
}

export default Login
